var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRcs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "120px",
    viewBox: "0 0 128 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Campaign-screen-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9-Copy",
    fill: "#F4F7FC",
    stroke: "#E7EEF1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 0.5,
    y: 0.5,
    width: 127,
    height: 119,
    rx: 8
  })), /*#__PURE__*/React.createElement("text", {
    id: "RCS",
    fontFamily: "Audiowide-Regular, Audiowide",
    fontSize: 16,
    fontWeight: "normal",
    fill: "#59616E"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 49,
    y: 66
  }, "RCS")), /*#__PURE__*/React.createElement("path", {
    d: "M39.4082201,39 L86.6,39 C90.1346224,39 93,41.8653776 93,45.4 L93,73.6 C93,77.1346224 90.1346224,80 86.6,80 L50.1628407,80 C46.634292,80 43.7714365,77.1440948 43.7628596,73.6155565 L43.715847,54.2745098 L43.715847,54.2745098 L37.1847377,42.8287499 C36.4840265,41.6007545 36.9114748,40.0372288 38.1394702,39.3365176 C38.525953,39.1159852 38.9632443,39 39.4082201,39 Z",
    id: "Path-2",
    stroke: "#728095",
    strokeWidth: 2.56
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcs);
export default __webpack_public_path__ + "static/media/RCS.3bd8b568b654f5f7c6e3744a5edda6bc.svg";
export { ForwardRef as ReactComponent };